import { jsx as e, jsxs as t } from "react/jsx-runtime";
// lib/PrintText/components/Text.tsx
var n = ({ children: n }) => /* @__PURE__ */ t("div", {
	className: "border-t flex items-baseline py-2 text-sm",
	children: [/* @__PURE__ */ e("label", {
		className: "text-sm opacity-70 w-14",
		contentEditable: !1,
		children: "Text"
	}), /* @__PURE__ */ e("div", { children: n })]
});
export { n as Text };
